module.exports = __webpack_public_path__ + "img/KSC02252.fbfefa50.jpg";